

















import {
	computed,
	defineComponent,
	PropType,
	watch,
} from '@vue/composition-api';
import { useIsError, useIsLoading, useIsUnstarted } from '@front-app/hooks/useAsyncStatus';
import { usePaginationFromList } from '@front-app/hooks/usePagination';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { useGroupMembersStore } from '@front-app/store/singletons/GroupMembers';
import { UserStore } from '@front-app/store/singletons/User';
import { MemberSort, useSortMemberRadio } from '../hooks/useSortMemberRadio';
import ListMembers from './ListMembers.vue';

export default defineComponent({
	components: { ListMembers },
	props: {
		groupId: {
			type: String,
			required: true,
		},
		roleFilter: {
			type: String as PropType<UserRole>,
			default: UserRole.MEMBER,
		},
		sortBy: {
			type: String as PropType<MemberSort>,
			default: MemberSort.ALPHABETICAL,
		},
		pageSize: {
			type: Number,
			required: true,
		},
	},
	setup(props, ctx) {
		const {
			status,
			getAdministrators,
		} = useGroupMembersStore(computed(() => props.groupId));

		// Member list
		const {
			sort,
		} = useSortMemberRadio(ctx, computed(() => props.sortBy));
		const allFilteredMembers = computed(() => getAdministrators().sort(sort));
		const isLoadingMembers = useIsLoading(status);
		const hasNotFetchedMembers = useIsUnstarted(status);
		const hasErrorLoadingMembers = useIsError(status);

		// Pagination
		const {
			numPages,
			currentPage,
			goToPage,
			goToNextPage,
			hasNextPage,
			goToPreviousPage,
			hasPrevPage,
		} = usePaginationFromList(allFilteredMembers, props.pageSize, 1);

		watch(() => props.sortBy, (prev, curr) => {
			if (prev === curr) {
				return;
			}
			goToPage(1);
		});

		const pagedMembers = computed(() => {
			const from = Math.max(0, currentPage.value - 1) * props.pageSize;
			const to = Math.min(Math.min(currentPage.value, numPages.value) * props.pageSize, allFilteredMembers.value.length);
			return allFilteredMembers.value.slice(from, to);
		});

		watch(pagedMembers, (curr, prev) => {
			if (curr === prev) {
				return;
			}
			const ids = curr
				.filter(({ groupRole }) => groupRole !== UserRole.EXTERNAL_INVITEE)
				.map(({ id }) => id);
			UserStore.getInstance().fetchMany(ids);
		}, { immediate: true });

		return {
			pagedMembers,
			numPages,
			currentPage,
			hasNextPage,
			hasPrevPage,
			isLoadingMembers,
			hasNotFetchedMembers,
			hasErrorLoadingMembers,
			goToPage,
			goToNextPage,
			goToPreviousPage,
		};
	},
});
